import styled from "styled-components";
export const OtherDocumentListWrapper = styled.div`
  .cell-documentName {
    min-width: 400px;
  }
  .cell-notes {
    min-width: 300px;
  }
  .cell-status {
    min-width: 165px;
  }

  .document-name-link {
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .badge-status {
    white-space: nowrap;
  }
`;
